import { getCustomAction, getMasterCustomLabels, saveCustomLabelValues } from './actions/PatientActions';
import _ from 'lodash';
import { connect } from 'react-redux';
import history from '../../../src/history';
import React from 'react';
import { CommonButton } from '../../components/buttons';
import TextField from 'material-ui/TextField';
import { base64Encode } from '../../actions/utilAction';

class CustomFields extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // patientId: props.patientId ? props.patientId : null,
      patientId: '',
      // dataFields: [],
      // get_custom: [],
      customDataFields: [],
      isTabChangeRequest: false,
    };
    this.fieldOnChange = this.fieldOnChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSaveContinue = this.handleSaveContinue.bind(this);
  };

  componentWillMount() {
    this.props.getMasterCustomLabels(this.props.patientId);
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.saved_customLabelValues && nextProps.saved_customLabelValues !== this.props.saved_customLabelValues) {
      if (this.state.isTabChangeRequest) {
        this.setState({ isTabChangeRequest: false });
        let patientId = base64Encode(`${this.props.patientId}`);        
        history.push(`/client/profile/${patientId}`);
      } else {
        this.props.getMasterCustomLabels(this.props.patientId);
      }
    }

    if (nextProps.masterCustomLabels && nextProps.masterCustomLabels !== this.props.masterCustomLabels) {
      let masterCustomLabels = nextProps.masterCustomLabels.data.MasterCustomLabels || [];
      let customLabelValues = nextProps.masterCustomLabels.data.PatientCustomLabels || [];
      let dataFields = [];
      masterCustomLabels.forEach((obj, index) => {
        let customLabelValueObj = customLabelValues.find((customObj) => customObj.customLabelID === obj.id);
        dataFields.push({
          ...customLabelValueObj,
          'patientID': this.props.patientId,
          'customLabelID': obj.id,
          'customLabelName': obj.customLabelName,
          customLabelValue: (customLabelValueObj && customLabelValueObj.customLabelValue) || '',
        });
      });
      this.setState({
        customDataFields: dataFields,
      });
    }
  }

  fieldOnChange(index, value) {
    let dataFields = this.state.customDataFields;
    if (!dataFields[index]) {
      dataFields.push({ customLabelValue: null });
      _.update(dataFields, `[${index}].customLabelValue`, function(n) {
        return value;
      });
    } else {
      _.update(dataFields, `[${index}].customLabelValue`, function(n) {
        return value;
      });
    }
    this.setState({
      customDataFields: dataFields,
    });
  }

  handleSaveContinue() {
    // let formData = (this.state.customDataFields || []);

    // if (!formData.length) {
    //   history.push(`/client/profile/${this.props.patientId}`);
    //   return false;
    // }
    // console.log(JSON.stringify(formData));
    // this.props.saveCustomLabelValues(formData);
    this.handleSave();
    this.props.handlePatientTabChange('6');
    // this.setState({ isTabChangeRequest: true });
  };

  handleSave= () => {
    let formData = (this.state.customDataFields || []);

    // console.log(JSON.stringify(formData));
    this.props.saveCustomLabelValues(formData);
  };

  renderCustomFields() {
    const customDataFields = this.state.customDataFields || [];

    if (!customDataFields.length) {
      return (
        <div className="col-sm-12 history_card">
          <div className="familydl text-center no-record">
            No record found.
          </div>
        </div>
      );
    }
    return customDataFields.map((field, index) => {
      return (
        <div key = {index} className ="col-sm-6 col-md-6">
          <TextField
            id= {index.toString()}
            name= {index.toString()}
            floatingLabelText={field.customLabelName}
            fullWidth={true}
            disabled = {this.props.isPatientProfilePage && this.props.isPatientProfilePage === true ? true : false}            
            autoComplete={'off'}
            floatingLabelStyle={{ color: '#7a7a7a' }}
            value={field.customLabelValue || ''}
            onChange={(e) => this.fieldOnChange(index, e.target.value)}
          />
        </div>
      );
    });
  };
  // renderFields() {
  //   // { console.log(this.state.dataFields); }
  //   return (this.props.masterCustomLabels && this.props.masterCustomLabels.data && this.props.masterCustomLabels.data.length > 0 ? this.props.masterCustomLabels.data.map((field, index) => {

  //     return (
  //       <div key = {index} className ="col-sm-4 col-md-4">
  //         <TextField
  //           id= {index.toString()}
  //           floatingLabelText={field.attributes.CustomLabelName}
  //           name= {index.toString()}
  //           // defaultValue= {defaultValue}
  //           disabled = {this.props.isPatientProfilePage && this.props.isPatientProfilePage === true ? true : false}
  //           fullWidth={true}
  //           className="valuefont"
  //           autoComplete={'off'}
  //           floatingLabelStyle={{ color: '#7a7a7a' }}
  //           value={this.state.dataFields && this.state.dataFields[index] && this.state.dataFields[index].customLabelValue ? this.state.dataFields[index].customLabelValue : undefined}
  //           onChange={(e) => this.fieldOnChange(index, e.target.value)}
  //         />
  //       </div>
  //     );
  //   })
  //     : '');
  // };

  render() {
    return (
      <div>
        <form className="readmin-form custom_form" onSubmit={(e) => {
          e.preventDefault();
          this.handleSave();
        } }>
          <div>
            <div className="row">
              {this.renderCustomFields()}
            </div>
          </div>
          {this.props.isPatientProfilePage && this.props.isPatientProfilePage === true ? '' : <div className="row">
            <div className="col-sm-12 pt20 btn_rt">
              {this.props.loading ? <CommonButton primary={true} className="loader_btn" disabled = {true } label= "Loading"/> : <CommonButton type="submit" primary={true} label= "Save"/>}
              <CommonButton className="ml_15" primary={true} label ="Save & Continue" onTouchTap={() =>
                this.handleSaveContinue()
              }/>

            </div>
          </div> }
        </form>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    masterCustomLabels: state.patient.masterCustomLabels,
    saved_customLabelValues: state.patient.saved_customLabelValues,
    loading: state.patient.loading,
  };
}


export default connect(mapStateToProps, { getMasterCustomLabels, getCustomAction, saveCustomLabelValues })(CustomFields);



// WEBPACK FOOTER //
// ./src/modules/patients/custom_fields.js